/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../apiResponse';
import { createApiResponseSchema } from '../apiResponse';
import { ticketSchema } from './ticket-schema';

const ticketListDataSchema = z.array(ticketSchema);

export const ticketListResponseSchema = createApiResponseSchema(
  ticketListDataSchema,
) as z.ZodSchema<IAPI<z.infer<typeof ticketListDataSchema>>>;

export type ITicketListResponse = IAPI<z.infer<typeof ticketListDataSchema>>;
